import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sbaAxios } from '../utils/sbaAxios';
import { getLeftMenuItems, InsertUpdateMenu, deleteMenuAndsubmenu} from "../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";

export const Menus = () => {
  const blankMenu={
    "MenuId": 0,
    "MenuName": "",
    "MenuDescription": "",
    "MenuLevel": null,
    "MenuParentId": 0,
    "MenuUrl": "",
    "SortOrder": null,
    "MenuImageUrl": "",
    "IsVisible": true,
    "IsEnabled": true,
    "LstChildMenu": [],
    "CreatedBy": 38
};

  const [menuData, setMenuData] = useState([]);
  const [submenuData, setSubMenuData] = useState([]);
  const [subChildMenuData,setSubChildMenuData]=useState([]);
  
  const [selectedMenu,setSeletctedMenu]=useState();
  const [selectedSubmenu,setSelectedSubmenu]=useState();
  const [showDrawer,setShowDrawer]=useState();
  const [drawerTitle,setDrawerTitle]=useState();
  const [newMenu,setNewMenu]=useState(blankMenu);
  const [render,setRedner]=useState(false);
  const [updtSortOder,setUptSortOrder]=useState(false);
  const [prevMenuData,setPrevMenuData]=useState([]);
  const [prevSubMenuData,setPrevSubMenuData]=useState([]);
    const [prevSubchildMenu, setPrevSubchildMenu] = useState([]);
    const [MenuId, setMenuId] = useState([]);
    const [Menuname, setMenuname] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showsubchld, setshowsubchld] = useState(false);

  const mainMenuREF= useRef();
  const subMenuREF =useRef();
  const subChildMenuREF =useRef();

  useEffect(()=>{
    const updatedSubMenu=menuData.find(item=>item?.MenuId===selectedMenu?.MenuId)?.LstChildMenu || [];
    const UpdateSUbChildMenu=updatedSubMenu.find(item=>item?.MenuId===selectedSubmenu?.MenuId)?.LstChildMenu || [];
    setSubMenuData(updatedSubMenu);
    setSubChildMenuData(UpdateSUbChildMenu);
  },[menuData]);

  useEffect(() => {
    menusListData();
  }, [render]);

  const menusListData = async () => {
    try {
        const response = await sbaAxios({
            url: `${getLeftMenuItems}`,
            method: 'get',
        })
      const data = response;
      setMenuData(data);
      setPrevMenuData(data);
    } catch (error) {
      console.error("Error fetching menusListData from API:", error);
    }
  };

  const onEditButtonClick=(menuData,type)=>{
    if(type==='mainMenu')
    {
      setDrawerTitle('Add / Update Main Menu');
      setNewMenu(menuData);
      setShowDrawer(true);
    }
    else if(type==='subMenu')
    {
      setDrawerTitle('Add / Update Sub Main Menu');
      setNewMenu(menuData);
      setShowDrawer(true);
    }
    else if(type==='subChildMenu')
    {
      setDrawerTitle('Add / Update Sub Child Main Menu');
      setNewMenu(menuData);
      setShowDrawer(true);
    }

    };
    const closeModal = () => {
        setShowModal(false);
    }
    const onDeleteClick = () => {
        sbaAxios({
            url: `${deleteMenuAndsubmenu}${MenuId}`,
            method: 'get',
        }).then(response => {  
            if ((response === -4444) || ((response === -5555))) {
                closeModal();
                toast.error("Delete Failed, Menu is mapped with role", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else if (response===-6666) {
                closeModal();
                toast.error("Delete Failed, Menu is mapped to submenu", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }

            else{
                closeModal();
                toast.success(`${Menuname} Deleted From the Menu`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                menusListData();
                //setTimeout(() => {
                //    menusListData();
                //}, 100);

            }
        }).catch(() => {
            toast.error("Error Occured while Operation", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        })
    };
    const EditButtonRenderer = (props) => {
        const menuData = props.data;
        const menuType = props.data.MenuLevel === 1 ? 'mainMenu' : props.data.MenuLevel === 2 ? 'subMenu' : props.data.MenuLevel === 3 ? 'subChildMenu' : '';
        const handleEditClick = () => {
            onEditButtonClick(menuData, menuType);
        }
            return (
                <div className="actions-cell">
                    <i
                        className="fas fa-edit"
                        style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                        onClick={handleEditClick}
                    ></i>
                </div>
            );
       
    }
    const DeleteButtonRenderer = (props) => {
      const MenuId = props.data.MenuId;
        const Menuname = props.data.MenuName;
        const handleDeleteClick = () => {
            setShowModal(true);
            setMenuId(MenuId);
            setMenuname(Menuname);

        };
    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };
  const MenuDef = [
    { headerName: "Menu Name", field: "MenuName" ,rowDrag: true,tooltipField: 'MenuName',},
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: EditButtonRenderer,
      maxWidth: 80,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: DeleteButtonRenderer,
    },
  ];
  const defaultColDef = {
    sortable: false,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
    const MainMenuRowClicked = (event) => {
    setSeletctedMenu(event.data);
        setSubMenuData(event.data.LstChildMenu);
        setSubChildMenuData([]);
        setPrevSubMenuData(event.data.LstChildMenu);
        setshowsubchld(false)
  }
    const subMenuRowClicked = (event) => {
    setSelectedSubmenu(event.data);
    setSubChildMenuData(event.data.LstChildMenu);
        setPrevSubchildMenu(event.data.LstChildMenu);
        setshowsubchld(true)
  }
  const AddMainMenu=()=>{
    setDrawerTitle("Add / Update Main Menu")
    setNewMenu({...blankMenu,MenuLevel:1});
    setShowDrawer(true);
  }
  const addSubMenu=()=>{
    setDrawerTitle("Add / Update Sub Menu");
    setNewMenu({...blankMenu,MenuLevel:2,MenuParentId:selectedMenu.MenuId});
    setShowDrawer(true);
  }
  const addSubChildMenu=()=>{
    setDrawerTitle("Add / Update Sub Child Menu");
    setNewMenu({...blankMenu,MenuLevel:3,MenuParentId:selectedSubmenu.MenuId});
    setShowDrawer(true);
  }
    const handleAddMenu = async () => {
        try {
            let saveSuccess = true;
            if (newMenu.MenuName === "") {
                saveSuccess = false;
                toast.error(`Please Enter MenuName`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            if (saveSuccess) {
                const response = await sbaAxios({
                    url: `${InsertUpdateMenu}`,
                    method: 'post',
                    data: newMenu,
                });
                if (response >0) {
                    toast.success(`${newMenu.MenuName} Successfully Updated`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setShowDrawer(false);
                    setRedner(!render);
                }
                else {
                    toast.error(`Failed to Update  ${newMenu.MenuName}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setShowDrawer(false);
                }
            }
        } catch (error) {
      setShowDrawer(false);
      console.error("Error updating Menu:", error);
    }
    //setSubMenuData(selectedMenu.filter(item=>item.menuId===newMenu.menuParentId));
  }
  const handleRowDragEnd=()=>{
    setUptSortOrder(true);
    const rows=[];
    mainMenuREF.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    const orderedMenu=rows.map((item,index)=>({...item,SortOrder:index}));
    setMenuData(orderedMenu);
  }
  const subMenuRowDragEnd=()=>{
    const rows=[];
    subMenuREF.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    const orderedSubMenu = rows.map((item,index)=>({...item,SortOrder:index}));
    // setMenuData(
    //   value=>(value.map(item=>{
    //   if(item.MenuId===selectedMenu.MenuId)
    //   {
    //     return {...item,LstChildMenu:orderedSubMenu}
    //   }
    //   else
    //   {
    //     return {...item}
    //   }
    // }))
    // )
    setSubMenuData(orderedSubMenu);
    setUptSortOrder(true);
  }
  const subChildMenuRowDragEnd=()=>{
    const rows=[];
    subChildMenuREF.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    const OrderedSubchidmenu = rows.map((item,index)=>({...item,SortOrder:index}));
    setSubChildMenuData(OrderedSubchidmenu);
    setUptSortOrder(true);
  }
  const updateSortOrder=()=>{
    let sortUpdated=true;
    const toBeSortedArray=[...menuData,...submenuData,...subChildMenuData,]
    toBeSortedArray.map(async (item)  =>{
        const response = await sbaAxios({
                url: `${InsertUpdateMenu}`,
                method: 'post',
                data: item,
            })            
      if(response<0)
      {
        sortUpdated = false;
      }
    }) 
    if(sortUpdated)
    {
      toast.success(`Sort Order Successfully Updated`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
    })
    }
    else
    {
      toast.error(`Error Updating Sort Order `, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
    })
    }
    setUptSortOrder(false);
  } 
  const cancelSort=()=>{
    console.log(prevMenuData,prevSubMenuData,prevSubchildMenu,'consolelogCancel')
    setMenuData(prevMenuData);
    setSubMenuData(prevSubMenuData);
    setSubChildMenuData(prevSubchildMenu);
    setUptSortOrder(false);
  }
  return <>
    <div className="row flex-wrap">
      <div className="col-md-4">
      <div className="header-container m-2 fs-12">
        <b>Available Menus</b>
        <button className="p-sm-btn mx-1" onClick={AddMainMenu}>
          <i className="fa-solid fa-plus" /> Add
        </button>
      </div>
      <div className="ag-theme-alpine m-1 " style={{ height: 450 }}>
        <AgGridReact
          columnDefs={MenuDef}
          rowData={menuData}
          defaultColDef={defaultColDef}
          onRowClicked={MainMenuRowClicked}
          rowSelection={'single'}
          rowDragManaged={true}
          onRowDragEnd={handleRowDragEnd}
          ref={mainMenuREF}
          animateRows={true}
          onGridReady={(params) => {
            params.api.sizeColumnsToFit()
        }}
        enableBrowserTooltips={true}
        tooltipInteraction={true}
          onRowDragLeave={handleRowDragEnd}
        />
      </div>
      </div>
      {selectedMenu && <><div className="col-md-4">
        <div className="header-container m-2 fs-12">
          <b>Available First Level Menus For ({selectedMenu.MenuName})</b>
          <button className="p-sm-btn mx-1" onClick={addSubMenu}>
            <i className="fa-solid fa-plus" /> Add
          </button>
        </div>
        <div className="ag-theme-alpine m-1" style={{ height: 450 }}>
          <AgGridReact
            columnDefs={MenuDef}
            rowData={submenuData}
            onRowClicked={subMenuRowClicked}
            defaultColDef={defaultColDef}
            rowSelection={'single'}
            rowDragManaged={true}
            ref={subMenuREF}
            animateRows={true}
          //   onGridReady={(params) => {
          //     subMenuREF.current = params.api;
          // }}
            enableBrowserTooltips={true}
            tooltipInteraction={true}
            onRowDragLeave={subMenuRowDragEnd}
            onRowDragEnd={subMenuRowDragEnd}
          />
        </div>
      </div> </>
      }
          {showsubchld && <><div className="col-md-4">
        <div className="header-container m-2 fs-12">
          <b>Available Second Level Menus For ({selectedSubmenu.MenuName})</b>
          <button className="p-sm-btn mx-1" onClick={addSubChildMenu}>
            <i className="fa-solid fa-plus" /> Add
          </button>
        </div>
        <div className="ag-theme-alpine m-1" style={{ height: 450 }}>
          <AgGridReact
            columnDefs={MenuDef}
            rowData={subChildMenuData}
            defaultColDef={defaultColDef}
            rowSelection={'single'}
            rowDragManaged={true}
            ref={subChildMenuREF}
            animateRows={true}
          //   onGridReady={(params) => {
          //     params.api.sizeColumnsToFit()
          // }}
          enableBrowserTooltips={true}
          tooltipInteraction={true}
            onRowDragLeave={subChildMenuRowDragEnd}
            onRowDragEnd={subChildMenuRowDragEnd}
          />
        </div>
      </div> </>
      }
    </div>
    {updtSortOder && <div className="d-flex">
      <div className="me-auto ms-auto py-2">
       <button className="s-lg-btn me-2" onClick={cancelSort}>Cancel</button>
       <button className="p-lg-btn" onClick={updateSortOrder}>update Sort Order</button>
      </div>
      
    </div> }
    <SBADrawer
      open={showDrawer}
      setOpen={setShowDrawer}
      close={false}
      title={drawerTitle}
    >
      <div>
        <label className="header-container m-1">
          <b>Menu Name</b>
        </label>
        <div className="mb-4">
          <input
            className="form-control w-75"
            type="text"
            value={newMenu.MenuName}
            onChange={(e) => setNewMenu({ ...newMenu, MenuName: e.target.value })}
          />
        </div>
       
        <label className="header-container m-1">
          <b>Menu Description</b>
        </label>
        <div className="mb-4">
          <input
            className="form-control w-75"
            type="text"
            value={newMenu.MenuDescription}
            onChange={(e) => setNewMenu({ ...newMenu, MenuDescription: e.target.value })}
          />
        </div>
        { newMenu.MenuLevel==1  &&
        <>
        <label className="header-container m-1">
          <b>Menu Image URL</b>
        </label>
        <div className="mb-4">
          <input
            className="form-control w-75"
            type="text"
            value={newMenu.MenuImageUrl}
            onChange={(e) => setNewMenu({ ...newMenu, MenuImageUrl: e.target.value })}
          />
        </div>
        </> }
        <label className="header-container m-1">
          <b>Sort Order</b>
        </label>
        <div className="mb-4">
          <input
            className="form-control w-75"
            type="number"
            value={newMenu.SortOrder}
            onChange={(e) => setNewMenu({ ...newMenu, SortOrder: e.target.value })}
          />
        </div>
        <label className="header-container m-1">
          <b>Enabled</b>
        </label>
        <div className="mb-4">
          <input
            type="checkbox"
            checked={newMenu.IsEnabled}
            onChange={(e) => setNewMenu({ ...newMenu, IsEnabled: e.target.checked })}
          />
        </div>
        <label className="header-container m-1">
          <b>Visible</b>
        </label>
        <div className="mb-4">
          <input
            type="checkbox"
            checked={newMenu.IsVisible}
            onChange={(e) => {setNewMenu({ ...newMenu, IsVisible: e.target.checked })}}
          />
        </div>
        <div className="mt-4">
              <button className="s-sm-btn mx-1" onClick={()=>setShowDrawer(false)}>
                Cancel
              </button>
              <button className="p-sm-btn mx-1" onClick={handleAddMenu}>
                Save
              </button>
        </div>
      </div>
      </SBADrawer>
      {<Modal show={showModal}>
          <Modal.Header closeButton onClick={closeModal}>
              <Modal.Title>Do you want to delete the selected Menu?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <p>The selected Menu will be deleted permanently. Are you sure?</p>
          </Modal.Body>
          <Modal.Footer>
              <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
              <button className='p-sm-btn mx-1' onClick={onDeleteClick} >
                  Yes
          </button>
          </Modal.Footer>
      </Modal>}
  </>
};



